import Loader from "components/common/loader";
import { DeleteModal } from "components/Modal/DeleteModal";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import ALLRoutes from "./router/router";

import { DialogModal } from "components/Modal/DialogModal";
import ImageModal from "components/Modal/ImageModal";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { setWebsiteReady, setLanguages } from "store/settingsSlice";
import { useAppSelector } from "store/store";
import { setThemeSettings } from "store/uiSlice";
import { languages } from "helpers/refs";
import sendRequest from "helpers/service";

const Feature = () => {
  const dispatch = useDispatch();
  const settings = useAppSelector((state) => state.settings);
  const themeOpen = useAppSelector((state) => state.ui.themeSettings);
  const headerCollapse = useAppSelector((state) => state.ui.headerCollapse);
  const mobileSidebar = useAppSelector((state) => state.ui.mobileSidebar);
  const miniSidebar = useAppSelector((state) => state.ui.miniSideBar);
  const expandMenu = useAppSelector((state) => state.ui.expandMenu);

  useEffect(() => {
    sendRequest
      .get({ url: "language/active" })
      .then((res: any) => {
        const langList = Array.isArray(res) ? res : (res?.data ?? []);
        // @ts-ignore
        languages.current = langList;
        dispatch(setLanguages(langList));
      })
      .catch(() => {
        // Fallback to defaults if API unavailable
        const defaults = [
          { id: 1, code: "tr", name: "Türkçe" },
          { id: 2, code: "en", name: "İngilizce" },
        ];
        // @ts-ignore
        languages.current = defaults;
        dispatch(setLanguages(defaults));
      })
      .finally(() => {
        dispatch(setWebsiteReady());
      });
  }, []);

  if (!settings.isReady) return <Loader isPage />;
  return (
    <div>
      <div
        id="main-wrapper"
        className={`main-wrapper 
        ${headerCollapse ? "header-collapse" : ""} 
        ${mobileSidebar ? "slide-nav" : ""}
        ${miniSidebar ? "mini-sidebar" : ""}
        ${expandMenu ? "expanded-menu" : ""}`}
      >
        <ALLRoutes />
      </div>
      <div className="sidebar-overlay"></div>
      <div
        className={`sidebar-themeoverlay ${themeOpen ? "open" : ""}`}
        onClick={() => dispatch(setThemeSettings(!themeOpen))}
      />
      <ToastContainer position="top-right" />
      <Loader />
      <DeleteModal />
      <DialogModal />
      <ImageModal />
    </div>
  );
};

export default Feature;
